module.exports = __webpack_public_path__ + "static/media/Newsletter-July.6712b8b5.pdf";